import { __assign } from "tslib";
import React, { useCallback, useContext, useMemo } from 'react';
import get from 'lodash/get';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook, ReferralType, } from '@wix/da-bi/pkg/constants';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useKeyDown } from '@wix/da-hooks/pkg/useKeyDown';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { NotificationType } from '../../../../Notifications';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import FavingIcon from '../../../../FaveButton/FavingIcon';
import ActionBarItemWrapper from '../../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../../_partials/items/ActionBarToggleButton';
import s from './FavouriteButton.scss';
function getFaveButtonBiData(isFavourite, isCollectionPanelOpen) {
    if (isCollectionPanelOpen) {
        return;
    }
    return BiData({
        evid: isFavourite ? 109 : 102,
        creatorid: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
    });
}
function getDeviationBiData(deviation) {
    return {
        creatorid: get(deviation, 'author.useridUuid'),
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
    };
}
var FavouriteButton = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType, isCollectionPanelOpen = _a.isCollectionPanelOpen, onToggleCollectionPanel = _a.onToggleCollectionPanel, onChangeFave = _a.onChangeFave, onArrowClick = _a.onArrowClick;
    var isMobile = useContext(MobileContext);
    var t = useTranslation().t;
    var restrictToLoggedIn = useRestrictToLoggedIn().restrictToLoggedIn;
    var keyboardShortcute = useMemo(function () { return ({
        // ctrl-g
        g: function (event) {
            if (actionBarType === 'primary' && event.ctrlKey) {
                onToggleCollectionPanel('primary');
            }
        },
    }); }, [actionBarType, onToggleCollectionPanel]);
    useKeyDown(keyboardShortcute);
    var isFavourited = !!deviation.isFavourited;
    var queueName = isMobile
        ? 'default'
        : getDeviationNotificationQueue(deviation);
    var onClick = function () {
        return onChangeFave(deviation, !isFavourited, queueName);
    };
    var FavingIconWithState = useCallback(function (iconProps) { return (React.createElement(FavingIcon, __assign({}, iconProps, { isFavourited: isFavourited, deviationId: deviation.deviationId }))); }, [isFavourited, deviation.deviationId]);
    return (React.createElement(BiLoggerContextProvider, { value: getDeviationBiData(deviation) },
        React.createElement(ActionBarItemWrapper, { notificationTypes: [
                NotificationType.Collect,
                NotificationType.CollectUndo,
                NotificationType.Fave,
                NotificationType.FaveUndo,
            ], popoverWrapperClassName: s['button-with-dropdown'], renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(React.Fragment, null,
                    React.createElement(ActionBarToggleButton, { onClick: onClick, activated: isCollectionPanelOpen, "data-hook": BiDataHook.DEVIATION_FAVE_BUTTON, label: isMobile
                            ? undefined
                            : t(isFavourited
                                ? 'actionbar.inFavourites'
                                : 'actionbar.addToFavourites'), biData: getFaveButtonBiData(isFavourited, isCollectionPanelOpen), icon: FavingIconWithState, iconRef: ref }),
                    React.createElement(PlainButtonOrLink, { className: s['arrow-down-wrapper'], onClick: restrictToLoggedIn(ReferralType.FAVOURITE, onArrowClick), biData: {
                            evid: BiEventType.POPUP_CLICK_ADD_TO_COLLECTION,
                            sectionname: 'arrowButton',
                        } },
                        React.createElement(ArrowDown, { size: IconSize.SMALLER }))));
            } })));
};
FavouriteButton.displayName = 'FavouriteButton';
export default FavouriteButton;
//# sourceMappingURL=FavouriteButton.js.map